const QR_BASE = "https://gateway.megriva.com/qrmenu";

export async function threedsInitialize({ token, payload }) {
  const res = await fetch(`${QR_BASE}/SubscriptionPayment/ThreedsInitialize`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return res.json();
}